/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerDeactivationDto } from '../../models/customer-deactivation-dto';

export interface ValidateCustomerDeactivation$Params {

/**
 * customer id
 */
  customerId: number;

/**
 * date of desired deactivation
 */
  dateOfDeactivation: string;
}

export function validateCustomerDeactivation(http: HttpClient, rootUrl: string, params: ValidateCustomerDeactivation$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerDeactivationDto>> {
  const rb = new RequestBuilder(rootUrl, validateCustomerDeactivation.PATH, 'get');
  if (params) {
    rb.path('customerId', params.customerId, {});
    rb.query('dateOfDeactivation', params.dateOfDeactivation, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CustomerDeactivationDto>;
    })
  );
}

validateCustomerDeactivation.PATH = '/customers/{customerId}/activation/validate-deactivation';
